import { qo } from '../../../shared/dom';

/** Coroa de louros em SVG: o emblema da Fortuna atrás do nome do ganhador. */
export function buildLaurel(): void {
  const el = qo('#laurel'); if (!el || el.dataset.done) return;
  const R = 43, cx = 50, cy = 56;
  const pt = (a: number): [number, number] => [cx + R * Math.cos(a * Math.PI / 180), cy + R * Math.sin(a * Math.PI / 180)];
  let g = '';
  const stem = (from: number, to: number): void => {
    const [x1, y1] = pt(from), [x2, y2] = pt(to);
    g += `<path d="M${x1.toFixed(1)} ${y1.toFixed(1)} A${R} ${R} 0 0 ${to > from ? 1 : 0} ${x2.toFixed(1)} ${y2.toFixed(1)}" fill="none" stroke="currentColor" stroke-width="1.2" opacity=".75"/>`;
  };
  const branch = (from: number, to: number, steps: number): void => {
    for (let i = 0; i < steps; i++) {
      const a = from + (to - from) * (i / (steps - 1));
      const r = R + (i % 2 ? 4 : -4);
      const px = cx + r * Math.cos(a * Math.PI / 180), py = cy + r * Math.sin(a * Math.PI / 180);
      const sc = .5 + .5 * Math.sin(Math.PI * i / (steps - 1));
      g += `<ellipse cx="${px.toFixed(1)}" cy="${py.toFixed(1)}" rx="${(7.6 * sc).toFixed(1)}" ry="${(3.2 * sc).toFixed(1)}" transform="rotate(${(a + 90).toFixed(1)} ${px.toFixed(1)} ${py.toFixed(1)})"/>`;
    }
  };
  stem(104, 232); stem(76, -52);
  branch(104, 232, 12); branch(76, -52, 12);
  el.innerHTML = `<svg viewBox="0 0 100 100" aria-hidden="true"><g fill="currentColor">${g}</g></svg>`;
  el.dataset.done = '1';
}
